export const NFSE_CONTENT = {
  hero: {
    kicker: 'Para prestadores de serviço de qualquer porte',
    title: 'Cada prefeitura tem seu próprio sistema de nota. O seu prestador de serviço não precisa sofrer com isso.',
    subtitle:
      'Emita NFS-e integrada às prefeituras de todo o Brasil, com o ISS calculado automaticamente e a nota gerada direto da venda ou da ordem de serviço concluída.',
    cta: 'Quero emitir NFS-e sem complicação',
    ctaMessage: 'Quero conhecer o emissor de NFS-e do 77Gestão',
    urgency: 'Enquanto você luta com o site da prefeitura, o prazo de emissão continua correndo.',
  },

  statsStrip: [
    { number: 'Brasil todo', label: 'integração com prefeituras', icon: 'fa-solid fa-map-location-dot' },
    { number: 'Automática', label: 'emissão a partir da venda ou OS', icon: 'fa-solid fa-bolt' },
    { number: 'Zero', label: 'cálculo manual de ISS', icon: 'fa-solid fa-calculator' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então a nota de serviço está tomando tempo que devia ser da operação.',
    intro:
      'Prestador de serviço não perde tempo por falta de organização — perde tempo porque cada prefeitura tem um sistema diferente, e emitir nota vira um processo manual e repetitivo.',
    items: [
      { icon: 'fa-solid fa-building-columns', text: 'Sistema da prefeitura lento, instável ou difícil de usar toda vez que precisa emitir.' },
      { icon: 'fa-solid fa-keyboard', text: 'Copiar dados do orçamento ou contrato à mão para gerar a nota de serviço.' },
      { icon: 'fa-solid fa-percent', text: 'Erro no cálculo do ISS por não saber a alíquota certa de cada serviço prestado.' },
      { icon: 'fa-solid fa-city', text: 'Cliente novo em outra cidade e você precisa aprender outro sistema municipal do zero.' },
      { icon: 'fa-regular fa-clock', text: 'Nota de serviço emitida fora do prazo por falta de tempo no meio da correria do dia.' },
    ],
  },

  midCta: {
    text: 'E se a NFS-e saísse sozinha assim que o serviço fosse concluído ou a venda fechada?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do emissor de NFS-e do 77Gestão',
  },

  solution: {
    title: 'Uma única tela para emitir nota de serviço em qualquer cidade do Brasil.',
    intro:
      'O emissor de NFS-e do 77Gestão conecta sua empresa aos principais provedores usados pelas prefeituras — sem você precisar aprender um sistema diferente para cada cliente.',
    cards: [
      {
        icon: 'fa-solid fa-map-location-dot',
        title: 'Integração com prefeituras de todo o Brasil',
        text: 'O sistema se conecta ao provedor da prefeitura do seu cliente (entre eles Acbr, SP, GissOnline e Nacional), sem você precisar acessar o portal da prefeitura.',
      },
      {
        icon: 'fa-solid fa-bolt',
        title: 'Emissão automática a partir da venda ou da OS',
        text: 'Feche uma venda de serviço ou conclua uma ordem de serviço, e a NFS-e é gerada automaticamente.',
      },
      {
        icon: 'fa-solid fa-calculator',
        title: 'Cálculo automático de ISS',
        text: 'Configure o cenário fiscal de cada serviço uma vez e o sistema aplica a alíquota certa em toda nota.',
      },
      {
        icon: 'fa-solid fa-file-circle-check',
        title: 'Cancelamento com protocolo',
        text: 'Emitiu errado? Cancele a NFS-e direto no sistema, com protocolo registrado.',
      },
      {
        icon: 'fa-solid fa-clock-rotate-left',
        title: 'Histórico completo por cliente e período',
        text: 'Consulte qualquer nota de serviço emitida, sem procurar e-mail ou acessar o site da prefeitura de novo.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a nota de serviço para de depender do site da prefeitura',
    intro:
      'Uma prestadora de serviços com clientes em várias cidades emitia nota manualmente em sites de prefeitura diferentes — um processo lento, repetido e sujeito a erro de alíquota.',
    stats: [
      { number: 'Automática', label: 'emissão a partir da OS concluída' },
      { number: '↓', label: 'tempo gasto emitindo nota por cliente' },
      { number: '0', label: 'acessos ao site da prefeitura' },
    ],
    paragraphs: [
      'Depois da implantação, a NFS-e passou a ser emitida automaticamente assim que a ordem de serviço era concluída, já com o ISS calculado conforme o cenário fiscal configurado.',
      'A equipe deixou de perder tempo entrando em portal de prefeitura para conferir status de nota — tudo passou a ficar disponível no histórico dentro do próprio sistema.',
    ],
    highlight: 'Resultado: menos tempo emitindo nota, menos erro de ISS e nenhuma dependência do site da prefeitura no dia a dia.',
    cta: 'Quero esse nível de agilidade',
    ctaMessage: 'Vi o resultado e quero entender como emitir NFS-e sem complicação no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares de uma emissão de NFS-e sem retrabalho',
    items: [
      {
        icon: 'fa-solid fa-bolt',
        title: 'Agilidade',
        text: 'A nota sai automaticamente da venda ou da ordem de serviço, sem passar pelo site da prefeitura.',
      },
      {
        icon: 'fa-solid fa-shield-halved',
        title: 'Conformidade',
        text: 'ISS calculado por cenário fiscal configurado, respeitando a regra de cada município atendido.',
      },
      {
        icon: 'fa-solid fa-link',
        title: 'Integração',
        text: 'Venda, ordem de serviço e nota fiscal no mesmo sistema, sem redigitar informação em outro lugar.',
      },
    ],
  },

  differentials: {
    title: 'Por que prestadores de serviço escolhem o 77Gestão para emitir NFS-e',
    items: [
      { icon: 'fa-solid fa-map-location-dot', text: 'Conecta com o provedor de nota fiscal da prefeitura do seu cliente, seja qual for a cidade.' },
      { icon: 'fa-solid fa-puzzle-piece', text: 'Emissão integrada à venda e à ordem de serviço — não é um sistema separado para alimentar.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: a configuração fiscal de cada serviço é feita junto com você.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano de verdade quando uma nota trava — sem fila de ticket.' },
      { icon: 'fa-solid fa-arrow-trend-up', text: 'Funciona para prestador autônomo, pequena empresa e operações com clientes em várias cidades.' },
    ],
  },

  faq: {
    title: 'Dúvidas antes de emitir sua primeira NFS-e',
    items: [
      {
        question: 'Minha prefeitura tem um sistema próprio, o 77Gestão consegue integrar mesmo assim?',
        answer:
          'Sim. O sistema já integra com múltiplos provedores usados pelas prefeituras de todo o Brasil (como Acbr, SP, GissOnline e Nacional), então a integração é configurada de acordo com a cidade do seu cliente.',
      },
      {
        question: 'Preciso configurar o ISS para cada serviço?',
        answer:
          'Sim, uma única vez. Você define o cenário fiscal de cada serviço e o sistema aplica a alíquota correta automaticamente em toda nota emitida a partir dali.',
      },
      {
        question: 'A nota sai sozinha quando eu fecho uma ordem de serviço?',
        answer:
          'Sim, a NFS-e pode ser gerada automaticamente a partir da venda ou da conclusão da ordem de serviço, sem precisar entrar em outro sistema.',
      },
      {
        question: 'Consigo cancelar uma NFS-e emitida errada?',
        answer:
          'Sim, dentro do prazo legal o cancelamento é feito direto no sistema, com protocolo registrado.',
      },
      {
        question: 'Atende prestador autônomo ou só empresa?',
        answer:
          'Atende os dois. O sistema é usado tanto por prestadores individuais quanto por empresas de serviço de portes variados.',
      },
    ],
  },

  ctaFinal: {
    title: 'Nota de serviço não devia depender do site da prefeitura.',
    subtitle:
      'Agende uma demonstração gratuita e veja como emitir NFS-e automaticamente, com o ISS calculado certo, em qualquer cidade que você atende.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do emissor de NFS-e do 77Gestão',
  },

  seo: {
    title: 'Emissor de NFS-e para Prestadores de Serviço | 77Gestão',
    description:
      'Emissor de NFS-e integrado a prefeituras de todo o Brasil, com emissão automática a partir da venda ou da ordem de serviço e cálculo de ISS certo.',
  },
};
